import { styled } from '@mui/system';
import { Badge as BaseBadge, badgeClasses } from '@mui/base/Badge';


export default function BadgeIndicator(props: any) {
  const { element, indicator } = props

  return (indicator ? (<Badge badgeContent={indicator}> {element} </Badge>) : <>{element}</>);
}

const Badge = styled(BaseBadge)(
  ({ theme }) => `
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-size: 14px;
  font-variant: tabular-nums;
  list-style: none;
  position: relative;
  display: inline-block;
  line-height: 1;

  & .${badgeClasses.badge} {
    z-index: auto;
    position: absolute;
    top: 0;
    right: 0;
    min-width: 20px;
    height: 20px;
    padding: 0 6px;
    color: #fff;
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
    white-space: nowrap;
    text-align: center;
    border-radius: 12px;
    background: ${'darkred'};
    transform: translate(50%, -50%);
    transform-origin: 100% 0;
  }
  `,
);